/*
    Create by fanglijuan 2016-04-22
*/
'use strict';
angular.module('createUserModule', [])
    .controller('createUserCtrl', ['$scope', '$element', '$location', '$stateParams', '$q', '$timeout', '$modalInstance', 'trsHttpService', 'treeService', '$state', '$validation', 'userid', 'whichTabShow', 'trsspliceString', 'userManageMentService', 'modalDialog', 'trsGroupTreeLocationService', 'editingCenterService',
        function($scope, $element, $location, $stateParams, $q, $timeout, $modalInstance, trsHttpService, treeService, $state, $validation, userid, whichTabShow, trsspliceString, userManageMentService, modalDialog, trsGroupTreeLocationService, editingCenterService) {
            initStatus();
            initData();

            /**
             * [initStatus 初始化状态]
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.repeatNum = false;
                $scope.repeatName = false;
                $scope.repeatLOGINACCOUNTNAME = false;
                $scope.status = {
                    UserId: userid,
                    whichTabShow: whichTabShow,
                    treeOptions: Object.assign(editingCenterService.channelTreeOptions(), {
                        injectClasses: {
                            labelSelected: 'rolegrouplabselected',
                        }, isLeaf: function(node) {
                            return node.HASCHILDREN === 'false';
                        },
                        isSelectable: function(node) {
                            return node.PARENTID !== '0';
                        },
                    }),
                    defultGroupid: !!$location.search().groupid, // 默认的groupid
                    pwdName: '密码',
                    passwordEqual: true,
                };
                $scope.static = {
                    ifExpand: true,
                    userGroup: '用户所属组织',
                    treeOptions: {
                        nodeChildren: 'CHILDREN',
                        dirSelectable: true,
                        allowDeselect: false,
                        injectClasses: {
                            ul: 'copyDraftTree-ul',
                            li: 'copyDraftTree-li',
                            liSelected: 'a7',
                            iExpanded: 'a3',
                            iCollapsed: 'a4',
                            iLeaf: 'a5',
                            label: 'copyDraftTree-label',
                            labelSelected: 'rolegrouplabselected',
                        },
                        isLeaf: function(node) {
                            return node.HASCHILDREN === 'false';
                        },
                        isSelectable: function(node) {
                            return node.PARENTID !== '0';
                        },
                    },
                };
                $scope.data1 = {};
                $scope.data = {
                    modalTitle: '新建用户',
                    selectedRole: [],
                    treeData: [],
                    groupPaths: [],
                    currUser: {
                        UserId: userid ? userid : 0,
                        USERNAME: '',
                    },
                    confIrmpwd: '',
                    selectedGroup: [],
                };
            }

            /**
             * [initData description] 初始化数据
             * @return  {[type]}  [return description]
             */
            function initData() {
                getTreeData();
                getTreeData1();
                requestData();

            }

            /**
             * [requestData 获取用户详细信息(初始化用户信息)]
             *
             * @return  {[type]}  [return description]
             */
            function requestData() {
                // add
                // 1.初始化用户，空对象；
                // 2验证保存提交用户 以及选择组织，后台返回UERID，
                // 3.判断是否有默认组织groupid ,有则查询该组织；
                // return;
                // edit
                // 1.根据uerid查询用户
                // 2.给currUser 赋值；
                // 3.给defaultRole 默认角色赋值
                // 4，查询出该用户所有组织，根据用户ID
                // 5，表单验证，比较用户，组织，角色，信息；注：要判断是否修改过用户信息，组织信息，角色信息；未修改不提交；
                // add;
                if ($scope.status.defultGroupid) {
                    getGroupPaths($stateParams.groupid, '/');
                }
            }


            /**
             * [checkNum 校验手机号码]
             * @return  {[type]}  [return description]
             */
            $scope.checkNum = function() {
                var defer = $q.defer();
                if ($scope.data.currUser.MOBILE && $scope.data.currUser.MOBILE) {
                    var paramsCreat = {
                        serviceid: 'mlf_usermanagement',
                        methodname: 'checkUserPhone',
                        PHONENUMBER: $scope.data.currUser.MOBILE,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), paramsCreat, 'get').then(function(data) {
                        if (data.TYPE * 1 !== 3) {
                            $scope.repeatNum = true;
                            defer.reject($scope.repeatNum);
                        } else {
                            $scope.repeatNum = false;
                            defer.resolve($scope.repeatNum);
                        }
                    });
                } else {
                    defer.reject();
                }
                return defer.promise;
            };

            /**
             * [checkUserName description] 校验用户名 已经是使用则不能使用
             * @param   {[type]}  isLoginName  [isLoginName description]
             * @return  {[type]}               [return description]
             */
            $scope.checkUserName = function () {
                let defer = $q.defer();
                if ($scope.data.currUser.LOGINACCOUNTNAME === $scope.status.oldLOGINACCOUNTNAME) {
                    defer.resolve();
                } else {
                    checkUserOrEmail(true).then(() => {
                        defer.resolve();
                    }, () => {
                        defer.reject();
                    });
                }
                return defer.promise;
            };

            /**
             * [checkUserEmail description] 检查用户邮箱
             * @return  {[type]}  [return description]
             */
            $scope.checkUserEmail = function (){
                if (!$scope.data.currUser.USERNAME) {return;}
                checkUserOrEmail();
            };

            /**
             * [checkUserOrEmail description] 检查用户名或邮箱
             * @param   {[type]}  isLoginName  [isLoginName description]
             * @return  {[type]}               [return description]
             */
            function checkUserOrEmail(isLoginName){
                let defer = $q.defer();
                var params = {
                    serviceid: 'mlf_usermanagement',
                    methodname: 'checkUserName',
                    UERNAME: $scope.data.currUser.USERNAME,
                    USERID: $scope.data.currUser.USERID * 1 === 0 ? '' : $scope.data.currUser.USERID,
                };
                if (isLoginName) {
                    params.USERATTR = 'LOGINACCOUNTNAME';
                    params.UERNAME = $scope.data.currUser.LOGINACCOUNTNAME;
                }
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    if (data.TYPE * 1 !== 3) {
                        if (isLoginName) {
                            $scope.repeatLOGINACCOUNTNAME = true;
                        } else {
                            $scope.repeatName = true;
                        }
                        defer.reject();
                    } else {
                        if (isLoginName) {
                            $scope.repeatLOGINACCOUNTNAME = false;
                        } else {
                            $scope.repeatName = false;
                        }
                        defer.resolve();
                    }
                });
                return defer.promise;
            }

            /**
             * [checkUserName 校验用户名 已经是使用则不能使用]
             * @param   {[type]}  isLoginName  [isLoginName 是否为检查登录用户名]
             * @return  {[type]}               [return description]
             */
            $scope.checkUserName = function() {
                if (!$scope.data.currUser.LOGINACCOUNTNAME) {return;} 
                checkUserOrEmail(true);
            };


            // 新建or修改：点击确定
            $scope.confirm = function() {
                if ($scope.status.whichTabShow === 'userInfo') {
                    doUserInfoNext(); // 填写完用户信息后的下一步
                } else if ($scope.status.whichTabShow === 'group') {
                    doGroupNext(); // 填写完所属组织后的下一步
                } else {
                    doConfirm(); // 最后一部
                }

                /**
                 * [selfCheckuserInfo 检查用户信息]
                 *
                 * @return  {[type]}  [return description]
                 */
                function selfCheckuserInfo() {
                    if ($scope.repeatName) {
                        $scope.status.whichTabShow = 'userInfo';
                        return true;
                    }
                    if ($scope.repeatLOGINACCOUNTNAME) {
                        $scope.status.whichTabShow = 'userInfo';
                        return true;
                    }
                    if ($scope.repeatNum) {
                        $scope.status.whichTabShow = 'userInfo';
                        return true;
                    }
                    return false;
                }

                /**
                 * [doUserInfoNext 执行下一步]
                 *
                 * @return  {[type]}  [return description]
                 */
                function doUserInfoNext() {
                    $validation.validate($scope.createUserSubmitForm).success(function() {
                        if (selfCheckuserInfo()) {
                            return;
                        }
                        $scope.status.whichTabShow = 'group';
                        $element.find('.body').eq(0).scrollTop(0);
                    }).error(function() {
                        $scope.status.whichTabShow = 'userInfo';
                        modalDialog.alertType('保存失败', '请检查填写项', 'error', 'confirm');
                    });
                }

                /**
                 * [doGroupNext 执行下一步]
                 *
                 * @return  {[type]}  [return description]
                 */
                function doGroupNext() {
                    $validation.validate($scope.createUserSubmitForm).success(function() {
                        if (selfCheckuserInfo()) {
                            return;
                        }
                        if ($location.search().status) {
                            // 组织不为空
                            if ($scope.data.groupPaths.length < 1) {
                                $scope.status.whichTabShow = 'group';
                                modalDialog.alertType('所属组织不允许为空', '', 'error', 'confirm');
                                return;
                            }
                            $scope.status.whichTabShow = 'role';
                            $('.publicModal>.body').scrollTop(0);
                        }
                    }).error(function() {
                        $scope.status.whichTabShow = 'userInfo';
                        modalDialog.alertType('保存失败', '请检查填写项', 'error', 'confirm');
                    });
                }

                /**
                 * [doConfirm 确认]
                 *
                 * @return  {[type]}  [return description]
                 */
                function doConfirm() { // 最后一步需要判断前两步是否正确
                    $validation.validate($scope.createUserSubmitForm).success(function() {
                        if (selfCheckuserInfo()) {
                            return;
                        }
                        if ($location.search().status) {
                            // 组织不为空
                            if ($scope.data.groupPaths.length < 1) {
                                $scope.status.whichTabShow = 'group';
                                modalDialog.alertType('所属组织不允许为空', '', 'error', 'confirm');
                                return;
                            }
                        }
                        $scope.loadingPromise = saveUser(angular.copy($scope.data.currUser), $scope.data.groupPaths, $scope.data.selectedRole).then(function() {
                            modalDialog.alertType('保存成功', '', 'success', false, function() {
                                $modalInstance.close();
                            });
                        });
                    }).error(function() {
                        $scope.status.whichTabShow = 'userInfo';
                        modalDialog.alertType('保存失败', '请检查填写项', 'error', 'confirm');
                    });
                }

            };

            /**
             * [saveUser 保存用户]
             *
             * @param   {[type]}  currUser      [currUser description]
             * @param   {[type]}  groupPaths    [groupPaths description]
             * @param   {[type]}  selectedRole  [selectedRole description]
             *
             * @return  {[type]}                [return description]
             */
            function saveUser(currUser, groupPaths, selectedRole) {
                var defer = $q.defer();
                var params = currUser;
                params.serviceid = 'mlf_usermanagement';
                params.methodname = 'saveUser'; // 新建用户
                params.EMAIL = $scope.data.currUser.USERNAME;
                if ($scope.status.defultGroupid) {
                    params.methodname = 'saveGroupUser'; // 组织下新建修改用户
                    params.GroupId = $location.search().groupid;
                }
                params.GroupIds = trsspliceString.spliceString(groupPaths, 'GROUPID', ',');
                if (selectedRole.length > 0) {
                    params.RoleIds = trsspliceString.spliceString(selectedRole, 'ROLEID', ',');
                }

                /* if ($scope.data.delSelectedRole > 0) {
                    delSelectedRole(); //删除角色
                }*/
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    defer.resolve('succsss');
                }, function() {
                    defer.reject('error');
                });
                return defer.promise;
            }

            /**
             * [showToggle description]树展开方法
             * @param  {[obj]} node [description]父节点
             * @return {[type]}        [description]
             */
            $scope.showToggle = function(node) {

                /* if (node.HASCHILDREN === "false" || (angular.isDefined(node.CHILDREN) && node.CHILDREN.length !== 0))
                    return;
                treeService.queryChildGroupsForGroupUserMgr("", node.GROUPID).then(function(data) {
                    node.CHILDREN = data.CHILDREN;
                });*/
                childrenTree(node, function() {
                });
            };

            /**
             * [childrenTree description获取子组织]
             * @param  {[type]}   node     [description]
             * @param  {Function} callback [description]
             * @return {[type]}            [description]
             */
            function childrenTree(node, callback) {
                if (node.HASCHILDREN == 'true' && node.CHILDREN.length === 0) {
                    var paramsT = {
                        'serviceid': 'mlf_group',
                        'methodname': 'queryChildGroupsWithSecondRight',
                        'GroupId': node.GROUPID,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), paramsT, 'get').then(function(dataC) {
                        node.CHILDREN = dataC.CHILDREN;
                        callback();
                    },
                    function(dataC) {
                        modalDialog.alertType('错误提示', '获取子组失败', 'error', 'confirm', function() {
                        });
                    });
                }
            }

            /**
             * [showSelected description]点击组织树节点
             * @param  {[obj]} node [description]点击的节点
             * @return {[type]}        [description]
             */
            $scope.showSelected = function(node) {
                $scope.GroupId = node.GROUPID;
            };

            /**
             * [getTreeData description]获取树数据
             * @param  {[obj]} params [description]请求参数
             * @param  {[string]} roleid   [description]角色Id非必传
             * @return {[type]}        [description]
             */
            function getTreeData() {
                treeService.queryGroupTreeWithSecondRight().then(function(data) {
                    $scope.data.treeData = [data];
                    ExpandedNodes();
                });
            }

            /**
             * [ExpandedNodes 默认展开树开始]
             *
             * @return  {[type]}  [return description]
             */
            function ExpandedNodes() {
                $scope.expandedTest = [];
                $scope.expandedTest.push($scope.data.treeData[0]);
                if ($scope.data.treeData[0].CHILDREN === 0) {
                    $scope.selectedNode = $scope.data.treeData[0];
                    getGroupData($scope.selectedNode);
                } else {
                    angular.forEach($scope.data.treeData[0].CHILDREN, function(data, index, array) {
                        if (data.ISPATH === 'true') {
                            $scope.expandedTest.push(data);
                            if (data.CHILDREN.length !== 0) {
                                // selfPath(data);
                            } else {
                                $scope.selectedNode = data;
                                getGroupData($scope.selectedNode);
                            }

                        }
                    });
                }
            }

            /**
             * [getGroupData 默认展开树结束]
             *
             * @param   {[type]}  node  [node description]
             *
             * @return  {[type]}        [return description]
             */
            function getGroupData(node) {
                $timeout(function() {
                    // 此判断如果两次点击同一个树，不重复加载角色列表。
                    if ($scope.oldSelectNode !== undefined && node.GROUPID == $scope.oldSelectNode.GROUPID) {
                        return;
                    }
                    $scope.groupObj = node;
                    $scope.oldSelectNode = node;
                    $scope.roleDatas = [];
                    $scope.roleData = null;
                    var params = {
                        'serviceid': 'mlf_extrole',
                        'methodname': 'query',
                        'GroupId': $scope.groupObj.GROUPID,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        $scope.data.roleDatas = data;
                    }, function(data) {
                    });
                }, 100);
            }

            // 点击树回调函数开始
            $scope.showSelected = function(node) {
                getGroupData(node);
            };
            // 点击树回调函数结束


            // 单击列表项效果
            $scope.chooseUserName = function(type, role) {
                if (angular.isDefined(role.selected) && role.selected === 'selected') {
                    role.selected = '';
                } else {
                    role.selected = 'selected';
                    if (type == 'toChoose') {
                        $scope.toChooseUser = role;
                    } else if (type == 'cancelChoose') {
                        $scope.cancelChooseUser = role;
                    }
                }
            };
            // 初始化选择列表
            $scope.toRight = function() {
                angular.forEach($scope.data.roleDatas, function(data, index, array) {
                    if (data.selected === 'selected') {
                        $scope.data.roleDatas[index].selected = '';
                        $scope.data.selectedRole.push(angular.copy($scope.data.roleDatas[index]));
                    }
                });
            };
            // 双击选择开始
            $scope.directlyToRight = function(role) {
                role.selected = '';
                $scope.data.selectedRole.push(angular.copy(role));
            };
            // 双击选择结束
            // 双击取消选择开始
            $scope.directlyToLeft = function(role) {
                role.selected = '';
                $scope.data.selectedRole.splice($scope.data.selectedRole.indexOf(role), 1);
            };
            // 双击取消选择结束
            // 选中删除
            $scope.toLeft = function() {
                var i = $scope.data.selectedRole.length - 1;
                while (i >= 0) {
                    if (angular.isDefined($scope.data.selectedRole[i]) && $scope.data.selectedRole[i].selected === 'selected') {
                        $scope.data.selectedRole.splice(i, 1);
                    }
                    i--;
                }
            };
            // 全选
            $scope.selectedAll = function() {
                $scope.data.selectedRole = [];
                angular.forEach($scope.data.roleDatas, function(data, index, array) {
                    $scope.data.roleDatas[index].selected = '';
                    $scope.data.selectedRole.push(angular.copy($scope.data.roleDatas[index]));
                });
            };
            // 全撤
            $scope.selectedNone = function() {
                $scope.data.selectedRole = [];
            };

            /**
             * [addGroup 添加用户组]
             *
             * @return  {[type]}  [return description]
             */
            $scope.addGroup = function() {
                userManageMentService.chooseGroup(angular.copy($scope.data.groupPaths)).then(function(data) {
                    getGroupPaths(data.groupIds, '/');
                    $scope.data.groupIds = data.groupIds;
                }, function(data) {

                });
            };

            /**
             * [getGroupPaths 根据组织IDS获取组织路径]
             *
             * @param   {[type]}  groupIds  [groupIds description]
             * @param   {[type]}  dcim      [dcim description]
             *
             * @return  {[type]}            [return description]
             */
            function getGroupPaths(groupIds, dcim) {
                var params = {
                    'serviceid': 'mlf_group',
                    'methodname': 'getGroupPaths',
                    'GroupIds': groupIds,
                    'dcim': dcim,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    // $scope.data.groupPaths = $filter('unique')($scope.data.groupPaths.concat(data), 'GROUPID');
                    for (var i = 0; i < data.length; i++) {
                        var as = data[i].GROUPPATHS.lastIndexOf('/') + 1;
                        data[i].GNAME = data[i].GROUPPATHS.slice(as);
                    }
                    $scope.data.groupPaths = data;
                    $scope.data.oldGroupPaths = angular.copy($scope.data.groupPaths);
                });
            }

            $scope.selectedGroup = function(group) {
                if ($scope.data.selectedGroup.indexOf(group) < 0) {
                    $scope.data.selectedGroup.push(group);
                } else {
                    $scope.data.selectedGroup.splice($scope.data.selectedGroup.indexOf(group), 1);
                }
            };
            $scope.resetscrTop = function() {
                $('.publicModal>.body').scrollTop(0);
                $timeout(function() {
                    $('div.footer').find('.mask').css('display', 'none');
                }, 0);
            };

            /**
             * [delGroups description]页面删除所属组织
             * @return {[type]} [description]
             */
            $scope.delGroups = function() {
                for (var i = 0; i < $scope.data.selectedGroup.length; i++) {
                    for (var j = 0; j < $scope.data.groupPaths.length; j++) {
                        if ($scope.data.groupPaths[j].GROUPID === $scope.data.selectedGroup[i].GROUPID) {
                            $scope.data.groupPaths.splice($scope.data.groupPaths.indexOf($scope.data.groupPaths[j]), 1);
                        }
                    }
                }
            };

            // 取消
            $scope.cancel = function() {
                if ($scope.status.whichTabShow == 'role') {
                    $scope.status.whichTabShow = 'group';
                    $('.publicModal>.body').scrollTop(0);
                } else if ($scope.status.whichTabShow == 'group') {
                    $scope.status.whichTabShow = 'userInfo';
                    $('.publicModal>.body').scrollTop(0);
                } else {
                    $modalInstance.dismiss();
                }
            };
            $scope.docancel = function() {
                $modalInstance.dismiss();
            };

            /**
             * [getSuggestions description]角色全局搜索
             * @param  {[type]} viewValue [description]
             * @return {[type]}           [description]
             */
            $scope.getSuggestions = function(viewValue) {
                if (viewValue != '') {
                    var searchUsers = {
                        serviceid: 'mlf_extrole',
                        methodname: 'searchRole',
                        Name: viewValue,
                        IsHasRight: true,
                    };
                    if ($scope.isRequest) {
                        $scope.isRequest = false;
                        return [];
                    } else {
                        return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), searchUsers, 'post').then(function(data) {
                            return data;
                        });
                    }
                }
            };
            $scope.$watch('searchRoleWord', function(newValue, oldValue) {
                if (angular.isObject(newValue)) {
                    var flag = true;
                    angular.forEach($scope.data.selectedRole, function(data, index, array) {
                        if (data.ROLEID == newValue.ROLEID) {
                            flag = false;
                        }
                    });
                    if (flag) {
                        $scope.isRequest = true;
                        $scope.data.selectedRole.push(newValue);
                    }
                    $scope.searchRoleWord = newValue.ROLENAME;
                }
            });

            /**
             * [showToggle description]树展开方法
             * @param  {[obj]} node [description]父节点
             * @return {[type]}        [description]
             */


            $scope.showToggle1 = function(node) {

                /* if (node.HASCHILDREN === "false" || (angular.isDefined(node.CHILDREN) && node.CHILDREN.length !== 0))
                    return;
                treeService.queryChildGroupsForGroupUserMgr("", node.GROUPID).then(function(data) {
                    node.CHILDREN = data.CHILDREN;
                });*/
                childrenTree1(node, function() {
                });
            };

            /**
             * [childrenTree description获取子组织]
             * @param  {[type]}   node     [description]
             * @param  {Function} callback [description]
             * @return {[type]}            [description]
             */
            function childrenTree1(node, callback) {
                if (node.HASCHILDREN == 'true' && node.CHILDREN.length === 0) {
                    var paramsT = {
                        'serviceid': 'mlf_group',
                        'methodname': 'queryChildGroupsWithSecondRight',
                        'GroupId': node.GROUPID,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), paramsT, 'get').then(function(dataC) {
                        node.CHILDREN = dataC.CHILDREN;
                        callback();
                    },
                    function(dataC) {
                        modalDialog.alertType('错误提示', '获取子组失败', 'error', 'confirm', function() {
                        });
                    });
                }
            }

            /**
             * [getTreeData description]获取树数据
             * @param  {[obj]} params [description]请求参数
             * @param  {[string]} roleid   [description]角色Id非必传
             * @return {[type]}        [description]
             */
            function getTreeData1() {
                treeService.queryGroupTreeWithSecondRight().then(function(data) {
                    $scope.data1.treeData = [data];
                    ExpandedNodes1();
                });
            }

            /**
             * [ExpandedNodes1 默认展开树开始]
             *
             * @return  {[type]}  [return description]
             */
            function ExpandedNodes1() {
                $scope.expandedTest1 = [];
                $scope.expandedTest1.push($scope.data1.treeData[0]);
                if ($scope.data1.treeData[0].CHILDREN === 0) {
                    $scope.selectedNode1 = $scope.data1.treeData[0];
                    getGroupData($scope.selectedNode1);
                } else {
                    angular.forEach($scope.data1.treeData[0].CHILDREN, function(data, index, array) {
                        if (data.ISPATH === 'true') {
                            $scope.expandedTest1.push(data);
                            if (data.CHILDREN.length !== 0) {
                                selfPath(data);
                            } else {
                                $scope.selectedNode1 = data;
                                getGroupData($scope.selectedNode1);
                            }
                        }
                    });
                }
            }

            /**
             * [getGroupData1 默认展开树结束]
             *
             * @param   {[type]}  node  [node description]
             *
             * @return  {[type]}        [return description]
             */
            function getGroupData1(node) {
                $timeout(function() {
                    $scope.groupObj = node;
                }, 100);
            }

            // 点击树回调函数开始
            $scope.showSelected1 = function(node) {
                getGroupData1(node);
            };
            // 点击树回调函数结束
            // 判断是否选中
            $scope.ifSelected1 = function(node) {
                var flag = false;
                for (var i = 0; i < $scope.data.groupPaths.length; i++) {
                    if (node.GROUPID === $scope.data.groupPaths[i].GROUPID) {
                        $scope.data.groupPaths[i].selected = true;
                        node.selected = true;
                        flag = true;
                        break;
                    }
                }
                return flag;
            };
            // 判断是否选中
            $scope.chooseGroup1 = function(node) {
                if (node.PARENTID == '0') {
                    return;
                }
                node.selected = !!(node.selected === undefined || node.selected === false);
                if (node.selected) {
                    $scope.data.groupPaths.push(node);
                } else {
                    cancelGroup1(node);
                }
            };

            /**
             * [cancelGroup1 取消组织]
             *
             * @param   {[type]}  group  [group description]
             *
             * @return  {[type]}         [return description]
             */
            function cancelGroup1(group) {
                angular.forEach($scope.data.groupPaths, function(data, index, array) {
                    if (data.GROUPID === group.GROUPID) {
                        $scope.data.groupPaths[index].selected = false;
                        $scope.data.groupPaths.splice(index, 1);
                    }
                });
            }

            $scope.cancelGroup1 = function(group) {
                cancelGroup1(group);
            };

            /**
             * [getSuggestions1] 匹配搜索框内关键词
             */
            var promise;
            $scope.getSuggestions1 = function(groupName) {
                if (promise) {
                    $timeout.cancel(promise);
                    promise = null;
                }
                promise = $timeout(function() {
                    if (groupName !== '') {
                        var params = {
                            serviceid: 'mlf_extuser',
                            methodname: 'searchGroup',
                            Name: groupName,
                        };
                        if ($scope.static.isRequest) {
                            $scope.static.isRequest = false;
                            return [];
                        } else {
                            return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                                return data;
                            });
                        }
                    }
                }, 10);
                return promise;
            };

            $scope.$watch('static.searchGroup', function(newValue, oldValue, scope) {
                if (angular.isObject(newValue)) {
                    $scope.static.isRequest = true;
                    locationGroupTree1(newValue.GROUPIDS);
                    // expandTreeAndSelectNode(newValue.GROUPIDS);
                    $scope.static.searchGroup = newValue.GNAME;
                }
            });

            /**
             * [locationGroupTree1 description] 定位目标节点在组织树中的位置
             * @param  {[type]} gropuIds [description]
             * @return {[type]}          [description]
             */
            function locationGroupTree1(gropuIds) {
                $scope.expandedTest1 = [];
                var groupidsArray = gropuIds.split(',');
                groupidsArray.splice(0, 1);
                if (groupidsArray.length === 0) {
                    $timeout(function() {
                        $scope.selectedNode1 = $scope.data1.treeData[0];
                        var isHasNode = false;
                        angular.forEach($scope.data.groupPaths, function(value, index) {
                            if (value.GROUPID == $scope.data1.treeData[0].GROUPID) {
                                isHasNode = true;
                            }
                        });
                        if (isHasNode === false) {
                            $scope.data1.treeData[0].selected = true;
                            $scope.data.groupPaths.push($scope.data1.treeData[0]);
                        }
                    });
                    return;
                }
                trsGroupTreeLocationService.groupTreeLocation(groupidsArray, $scope.data1.treeData[0], $scope.selectedNode1, $scope.expandedTest1, function(tree, array, selectedNode1) {
                    delete $scope.data1.treeData;
                    $scope.data1.treeData = [tree];
                    $scope.expandedTest1.push($scope.data1.treeData[0]);
                    $scope.selectedNode1 = selectedNode1;
                    var isHasNode = false;
                    angular.forEach($scope.data.groupPaths, function(value, index) {
                        if (value.GROUPID == selectedNode1.GROUPID) {
                            isHasNode = true;
                        }
                    });
                    if (isHasNode === false) {
                        selectedNode1.selected = true;
                        $scope.data.groupPaths.push(selectedNode1);
                    }
                });
            }
        },
    ]);
